export const resources = {
  ConfirmExitIndexingTitle: '',
  ConfirmExitIndexingDescription: '',
  ConfirmExitIndexingLeaveButton: '',
  Cancel: ''
};
